import { API } from "./types";
import { fetchResource } from "./utils";

export const getManager = (id: string) =>
  fetchResource<API.Manager>(`/managers/${id}`);

export const getManagerNews = (
  id: string,
  options?: {
    limit?: number;
    offset?: number;
    after?: string;
  }
) => {
  let route = `/managers/${id}/news`;
  const query = new URLSearchParams();
  if (options?.limit) query.append("limit", String(options.limit));
  if (options?.offset) query.append("offset", String(options.offset));
  if (options?.after) query.append("after", String(options.after));
  if (query.toString()) route = `${route}?${query}`;
  return fetchResource<API.Article[]>(route);
};

export const getManagerHistory = (id: string) =>
  fetchResource<API.ManagerHistory[]>(`/managers/${id}/history`);
